var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSidebarCollapse = function SvgSidebarCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16Z",
    fill: "#E5EBED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.943 16 3.528-3.529a.666.666 0 1 0-.942-.942l-4 4a.666.666 0 0 0 0 .942l4 4a.666.666 0 1 0 .942-.942L14.943 16Z",
    fill: "#2C3439"
  })));
};
export default SvgSidebarCollapse;